import {useNavigate} from "react-router-dom";
import {Button} from "@reside/ui";
import {SftpConfig} from "../../services/HubAndSpokeService";
import {AdminPageTitle} from "../../atoms/admin-layout/AdminPageTitle";
import {ButtonLink} from "../../atoms/button-link";
import {Column, ListTable} from "../../atoms/list-table";
import {Space} from "../../atoms/space";
import {Spinner} from "../../atoms/spinner";
import {useSftpConfigsQuery} from "./hooks/useSftpConfigsQuery";
import {useDeleteSftpConfig} from "./hooks/useDeleteSftpConfig";
import {HubAndSpokeListTableScroll} from "./atoms/HubAndSpokeListTableScroll";
import {HubAndSpokePageHeader} from "./styles";

type Row = {
  rowData: SftpConfig;
};

const SFTP_CONFIGURATIONS_PATH = "/admin/hub-and-spoke/sftp-configurations";
/** Visual minimap segments (not tied to actual column count). */
const SFTP_LIST_MINIMAP_TICKS = 6;

export const SftpConfigurations = () => {
  const navigate = useNavigate();

  const {data, isLoading} = useSftpConfigsQuery();
  const {
    mutate: deleteSftpConfig,
    isLoading: isLoadingDeleteSftpConfig,
    variables: deletedSftpConfigId,
  } = useDeleteSftpConfig();

  return (
    <>
      {!isLoading && data ? (
        <>
          <HubAndSpokePageHeader>
            <AdminPageTitle>SFTP Configurations</AdminPageTitle>
            <Space>
              <ButtonLink
                to={`${SFTP_CONFIGURATIONS_PATH}/create`}
                color="primary"
                outline={false}
                testId="add-target-form-button"
              >
                New SFTP Configuration
              </ButtonLink>
            </Space>
          </HubAndSpokePageHeader>
          <HubAndSpokeListTableScroll minimapTicks={SFTP_LIST_MINIMAP_TICKS}>
            <ListTable
              key="sftp-configs"
              sortedData={data}
              getRowId={row => row.rowData.id}
              rowHeight={150}
            >
              <Column
                cellRenderer={(row: Row) => <p>{row.rowData.name}</p>}
                label="Name"
                sortKey="name"
                width={150}
              />
              <Column
                cellRenderer={(row: Row) => <p>{row.rowData.hostname}</p>}
                label="Hostname/IP Address"
                sortKey="hostname"
                width={100}
              />
              <Column
                cellRenderer={(row: Row) => <p>{row.rowData.port}</p>}
                label="Port"
                sortKey="port"
                width={20}
              />
              <Column
                cellRenderer={(row: Row) => <p>{row.rowData.notes}</p>}
                label="Notes"
                sortKey="notes"
                width={300}
              />
              <Column
                cellRenderer={({rowData: {id}}: Row) => (
                  <Button
                    onClick={() =>
                      navigate(`${SFTP_CONFIGURATIONS_PATH}/${id}/edit`)
                    }
                    color="default"
                    testId="edit-target-form-button"
                  >
                    Edit
                  </Button>
                )}
                width={50}
              />
              <Column
                cellRenderer={({rowData: {id}}: Row) => (
                  <Button
                    onClick={() => deleteSftpConfig(id)}
                    disabled={
                      isLoadingDeleteSftpConfig && deletedSftpConfigId === id
                    }
                  >
                    {isLoadingDeleteSftpConfig && deletedSftpConfigId === id
                      ? "Deleting Configuration..."
                      : "Delete"}
                  </Button>
                )}
                width={50}
              />
            </ListTable>
          </HubAndSpokeListTableScroll>
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
};
